import Repository from './Repository';

class SidebarRepository extends Repository {
	fetchAll (request) {
		// request string should be empty or a standard url query string: 'key=value&...'
		let requestString = '';
		for (const [ key, value ] of Object.entries(request)) {
			if (!request.hasOwnProperty(key)) {
				continue;
			}

			// 'clear_data is an additional piece of information for the action
			// and does not need to be included in the api request
			if (key === 'clear_data') {
				continue;
			}

			if (requestString !== '') {
				requestString += '&';
			}

			requestString += `${key}=${value}`;
		}

		return this.getWithToken(`/clients/all?${requestString}`);
	}
}

export default new SidebarRepository();
